import { render } from "./AddSales.vue?vue&type=template&id=68574acb"
import script from "./AddSales.vue?vue&type=script&lang=js"
export * from "./AddSales.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script